import { TGamePhase, useGame } from "../../data/gameContext";

interface IGamePausedProps {
    prevPhase: TGamePhase;
    resumeGame: () => void;
}

export default function GamePaused(props: IGamePausedProps) {
    const { gameState } = useGame();

    function handleSaveAndQuit() {
        let saveState = structuredClone(gameState);
        saveState.Phase = props.prevPhase;
        localStorage.setItem("savedGame", JSON.stringify(saveState));
        window.location.href = "/";
    }


    return (
        <div className="paused-overlay">
        <div className="paused-content">
          <h2>Game Paused</h2>
          <button onClick={props.resumeGame}>Continue</button>
          <button onClick={handleSaveAndQuit}>Save and Quit</button>
        </div>
      </div>
    )
}